//Taken from https://github.com/flrent/States.js
export default {
    Countries: [
        {
            n: 'Canada',
            v: 'CA',
            s: [
                {
                    n: 'Alberta',
                    v: 'AB'
                },
                {
                    n: 'British Columbia',
                    v: 'BC'
                },
                {
                    n: 'Manitoba',
                    v: 'MB'
                },
                {
                    n: 'New Brunswick',
                    v: 'NB'
                },
                {
                    n: 'Newfoundland',
                    v: 'NL'
                },
                {
                    n: 'Northwest Territories',
                    v: 'NT'
                },
                {
                    n: 'Nova Scotia',
                    v: 'NS'
                },
                {
                    n: 'Nunavut',
                    v: 'NU'
                },
                {
                    n: 'Ontario',
                    v: 'ON'
                },
                {
                    n: 'Prince Edward Island',
                    v: 'PE'
                },
                {
                    n: 'Quebec',
                    v: 'QC'
                },
                {
                    n: 'Saskatchewan',
                    v: 'SK'
                },
                {
                    n: 'Yukon Territory',
                    v: 'YT'
                }
            ]
        },
        {
            n: 'United States',
            v: 'US',
            s: [
                {
                    n: 'Alabama',
                    v: 'AL'
                },
                {
                    n: 'Alaska',
                    v: 'AK'
                },
                {
                    n: 'Arizona',
                    v: 'AZ'
                },
                {
                    n: 'Arkansas',
                    v: 'AR'
                },
                {
                    n: 'California',
                    v: 'CA'
                },
                {
                    n: 'Colorado',
                    v: 'CO'
                },
                {
                    n: 'Connecticut',
                    v: 'CT'
                },
                {
                    n: 'Delaware',
                    v: 'DE'
                },
                {
                    n: 'District of Columbia',
                    v: 'DC'
                },
                {
                    n: 'Florida',
                    v: 'FL'
                },
                {
                    n: 'Georgia',
                    v: 'GA'
                },
                {
                    n: 'Hawaii',
                    v: 'HI'
                },
                {
                    n: 'Idaho',
                    v: 'ID'
                },
                {
                    n: 'Illinois',
                    v: 'IL'
                },
                {
                    n: 'Indiana',
                    v: 'IN'
                },
                {
                    n: 'Iowa',
                    v: 'IA'
                },
                {
                    n: 'Kansas',
                    v: 'KS'
                },
                {
                    n: 'Kentucky',
                    v: 'KY'
                },
                {
                    n: 'Louisiana',
                    v: 'LA'
                },
                {
                    n: 'Maine',
                    v: 'ME'
                },
                {
                    n: 'Maryland',
                    v: 'MD'
                },
                {
                    n: 'Massachusetts',
                    v: 'MA'
                },
                {
                    n: 'Michigan',
                    v: 'MI'
                },
                {
                    n: 'Minnesota',
                    v: 'Mn'
                },
                {
                    n: 'Mississippi',
                    v: 'MS'
                },
                {
                    n: 'Missouri',
                    v: 'MO'
                },
                {
                    n: 'Montana',
                    v: 'MT'
                },
                {
                    n: 'Nebraska',
                    v: 'NE'
                },
                {
                    n: 'Nevada',
                    v: 'NV'
                },
                {
                    n: 'New Hampshire',
                    v: 'NH'
                },
                {
                    n: 'New Jersey',
                    v: 'NJ'
                },
                {
                    n: 'New Mexico',
                    v: 'NM'
                },
                {
                    n: 'New York',
                    v: 'NY'
                },
                {
                    n: 'North Carolina',
                    v: 'NC'
                },
                {
                    n: 'North Dakota',
                    v: 'ND'
                },
                {
                    n: 'Ohio',
                    v: 'OH'
                },
                {
                    n: 'Oklahoma',
                    v: 'OK'
                },
                {
                    n: 'Oregon',
                    v: 'OR'
                },
                {
                    n: 'Pennsylvania',
                    v: 'PA'
                },
                {
                    n: 'Rhode Island',
                    v: 'RI'
                },
                {
                    n: 'South Carolina',
                    v: 'SC'
                },
                {
                    n: 'South Dakota',
                    v: 'SD'
                },
                {
                    n: 'Tennessee',
                    v: 'TN'
                },
                {
                    n: 'Texas',
                    v: 'TX'
                },
                {
                    n: 'Utah',
                    v: 'UT'
                },
                {
                    n: 'Vermont',
                    v: 'VT'
                },
                {
                    n: 'Virginia',
                    v: 'VA'
                },
                {
                    n: 'Washington',
                    v: 'WA'
                },
                {
                    n: 'West Virginia',
                    v: 'WV'
                },
                {
                    n: 'Wisconsin',
                    v: 'WI'
                },
                {
                    n: 'Wyoming',
                    v: 'WY'
                }
            ]
        },
        {
            n: 'Australia',
            v: 'AU',
            s: [
                {
                    n: 'Australian Capital Territory',
                    v: 'ACT'
                },
                {
                    n: 'New South Wales',
                    v: 'NSW'
                },
                {
                    n: 'Northern Territory',
                    v: 'NT'
                },
                {
                    n: 'Queensland',
                    v: 'QLD'
                },
                {
                    n: 'SA',
                    v: 'South Australia'
                },
                {
                    n: 'Tasmania',
                    v: 'TAS'
                },
                {
                    n: 'Victoria',
                    v: 'VIC'
                },
                {
                    n: 'Western Australia',
                    v: 'WA'
                }
            ]
        }
    ]
};
